var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadband(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.109,
    height: 19.142,
    viewBox: "0 0 22.109 19.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_broadband_1641327",
    transform: "translate(-13.644 -16.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(13.744 16.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(3.591 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(9.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M41.018,20.168a.427.427,0,0,1-.3-.729,3.364,3.364,0,0,0,0-4.752.427.427,0,0,1,.6-.6,4.219,4.219,0,0,1,0,5.961A.426.426,0,0,1,41.018,20.168Z",
    transform: "translate(-40.59 -13.957)",
    fill: "#db5f28",
    stroke: "#db5f28",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(1.739 0.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M36.9,20.482a.427.427,0,0,1-.3-.729,2.058,2.058,0,0,0,0-2.91.427.427,0,0,1,.6-.6,2.912,2.912,0,0,1,0,4.118A.426.426,0,0,1,36.9,20.482Z",
    transform: "translate(-36.47 -16.114)",
    fill: "#db5f28",
    stroke: "#db5f28",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(0 1.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M32.826,20.789a.427.427,0,0,1-.3-.729.784.784,0,0,0,0-1.108.427.427,0,0,1,.6-.6,1.639,1.639,0,0,1,0,2.316A.426.426,0,0,1,32.826,20.789Z",
    transform: "translate(-32.399 -18.222)",
    fill: "#db5f28",
    stroke: "#db5f28",
    strokeWidth: 0.2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M12.537,20.168a.426.426,0,0,1-.3-.125,4.219,4.219,0,0,1,0-5.961.427.427,0,0,1,.6.6,3.364,3.364,0,0,0,0,4.752.427.427,0,0,1-.3.729Z",
    transform: "translate(-11.002 -13.957)",
    fill: "#db5f28",
    stroke: "#db5f28",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(2.14 0.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M17.166,20.482a.426.426,0,0,1-.3-.125,2.912,2.912,0,0,1,0-4.118.427.427,0,0,1,.6.6,2.058,2.058,0,0,0,0,2.91.427.427,0,0,1-.3.729Z",
    transform: "translate(-16.011 -16.114)",
    fill: "#db5f28",
    stroke: "#db5f28",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(4.254 1.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M21.74,20.789a.426.426,0,0,1-.3-.125,1.639,1.639,0,0,1,0-2.316.427.427,0,0,1,.6.6.784.784,0,0,0,0,1.108.427.427,0,0,1-.3.729Z",
    transform: "translate(-20.958 -18.222)",
    fill: "#db5f28",
    stroke: "#db5f28",
    strokeWidth: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(6.875 5.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M27.52,34.831a.427.427,0,0,1-.427-.427V26.946a.427.427,0,1,1,.855,0V34.4A.427.427,0,0,1,27.52,34.831Z",
    transform: "translate(-27.092 -26.519)",
    fill: "#0077b6",
    stroke: "#0077b6",
    strokeWidth: 0.2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(0 12.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M37.053,50.243H18.5a1.679,1.679,0,0,1-1.677-1.677V45.651A1.679,1.679,0,0,1,18.5,43.974H37.053a1.679,1.679,0,0,1,1.677,1.677v2.916A1.679,1.679,0,0,1,37.053,50.243ZM18.5,45.013a.638.638,0,0,0-.638.638v2.916a.638.638,0,0,0,.638.638H37.053a.638.638,0,0,0,.638-.638V45.651a.638.638,0,0,0-.638-.638Z",
    transform: "translate(-16.821 -43.974)",
    fill: "#0077b6",
    stroke: "#0077b6",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(2.041 1.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M21.269,48.492a.518.518,0,0,1-.369-.156.521.521,0,0,1,0-.733.537.537,0,0,1,.733,0,.966.966,0,0,1,.067.078.828.828,0,0,1,.047.089.35.35,0,0,1,.031.1.654.654,0,0,1,.011.1.532.532,0,0,1-.519.519Z",
    transform: "translate(-20.75 -47.46)",
    fill: "#0077b6",
    stroke: "#0077b6",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0 1.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M21.269,51.622a.518.518,0,0,1-.369-.156.538.538,0,0,1-.115-.166.514.514,0,0,1-.036-.2.505.505,0,0,1,.151-.369.538.538,0,0,1,.733,0,.512.512,0,0,1,.156.369.519.519,0,0,1-.042.2.456.456,0,0,1-.114.166A.508.508,0,0,1,21.269,51.622Z",
    transform: "translate(-20.75 -50.59)",
    fill: "#0077b6",
    stroke: "#0077b6",
    strokeWidth: 0.2
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadband);
export default __webpack_public_path__ + "static/media/broadband.ec5ccb782977fe0a88d72583a3d414d9.svg";
export { ForwardRef as ReactComponent };